import { StoreDetails } from 'components/account/StoreDetails';
import { ExternalLinkIcon } from 'components/icons';
import { LoadingSpinner } from 'components/ui';
import { useGetStoresQuery } from 'store/services/segmentsApi';
import { usePageTitle } from 'utils';

export default function ManageStores() {
  usePageTitle('Manage stores | Segments');

  const { data: stores, isFetching } = useGetStoresQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });

  return (
    <div className="relative max-w-screen-xl px-5 mx-auto md:pl-segments-72px md:pr-20 py-11">
      <div className="justify-between md:flex">
        <div>
          <p className="font-bold">Settings</p>
          <h1 className="font-bold text-segments-44px">Manage stores</h1>
        </div>
        <div className="self-end mt-3 lg:mt-0">
          <a
            href="https://apps.shopify.com/segments"
            className="flex justify-center w-full p-4 space-x-2 text-base font-bold text-white border focus:outline-none border-segments-accent-color-1 rounded-2xl bg-segments-accent-color-1 hover:bg-segments-dark"
            target="_blank"
            rel="noreferrer"
          >
            <span>Add new store</span>
            <ExternalLinkIcon className="text-white" />
          </a>
        </div>
      </div>
      <div className="mt-16 text-2xl">
        <h3>Your stores</h3>

        {isFetching ? (
          <div className="grid mt-52 place-items-center">
            <LoadingSpinner className="w-20 h-20 text-segments-accent-color-orange" />
          </div>
        ) : (
          stores?.map((store) => (
            <StoreDetails storeName={store.store_name} key={store.id} />
          ))
        )}
      </div>
    </div>
  );
}
